var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" Valitettavasti hakemaasi sivua ei löytynyt – se on mahdollisesti joko siirretty tai poistettu. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }